<template>
  <v-container class="d-flex align-center justify-center" fluid style="height: 100vh;">
    <div>
      <v-row class="pa-5" style="background-color: #00F784">
        <h2 class="text-center">{{ title }}</h2>
      </v-row>
      <v-row>
        <p class="text-center">{{ text }}</p>
      </v-row>
      <v-btn @click="goToUrl" style="width: 100%">{{ buttonText }}</v-btn>
    </div>
  </v-container>
</template>

<script>
export default {
  name: "CollapsedNotification",
  props: {
    title: String,
    text: String,
    buttonText: String,
    buttonUrl: String,
  },
  methods: {
    goToUrl() {
      this.$router.push(`/${this.buttonUrl}`);
    },
  },
}
</script>

<style scoped>

</style>
